export default {
  title: 'Contas de canal',
  description: 'Configure as contas utilizadas para enviar e, quando disponível, receber mensagens pelos canais de comunicação da empresa.',
  fields: {
    name: 'Nome',
    channel: 'Canal',
    connectionType: 'Tipo',
    account: 'Conta / remetente',
    validation: 'Validação',
    credential: 'Credencial',
    active: 'Ativa',
    lastValidatedAt: 'Última validação',
    updatedAt: 'Atualizado em',
    fromAddress: 'E-mail remetente',
    fromName: 'Nome do remetente',
    host: 'Servidor SMTP',
    port: 'Porta',
    secure: 'TLS implícito',
    requireTls: 'Exigir STARTTLS',
    connectionTimeout: 'Timeout de conexão (ms)',
    greetingTimeout: 'Timeout de saudação (ms)',
    socketTimeout: 'Timeout do socket (ms)',
    username: 'Usuário',
    password: 'Senha',
  },
  form: {
    title: 'Conta de canal',
    groups: {
      general: 'Geral',
      settings: 'Configurações',
    },
  },
  channels: {
    email: 'E-mail',
  },
  connectionTypes: {
    smtpNative: 'SMTP nativo',
    provider: 'Provider',
  },
  values: {
    unknown: 'Desconhecido',
  },
  validation: {
    unvalidated: 'Não validada',
    valid: 'Válida',
    invalid: 'Inválida',
  },
  credentials: {
    configured: 'Configurada',
    notConfigured: 'Não configurada',
  },
  states: {
    active: 'Ativa',
    inactive: 'Inativa',
  },
  actions: {
    credential: 'Definir credencial',
    credentialTooltip: 'Definir ou substituir a credencial desta conta',
    validate: 'Testar conexão',
    validateTooltip: 'Validar configuração e credencial no canal',
    activate: 'Ativar',
    activateTooltip: 'Ativar esta conta de canal',
    deactivate: 'Desativar',
    deactivateTooltip: 'Desativar esta conta de canal',
  },
  dialogs: {
    credentialTitle: 'Credencial SMTP',
    credentialDescription: 'A credencial é enviada ao Communication e não poderá ser consultada depois.',
  },
  confirmations: {
    validateTitle: 'Testar conexão',
    validate: 'Testar agora a configuração e a credencial desta conta?',
    activateTitle: 'Ativar conta',
    activate: 'Ativar esta conta para uso pelo Communication?',
    deactivateTitle: 'Desativar conta',
    deactivate: 'Desativar esta conta de canal?',
  },
  messages: {
    credentialSaved: 'Credencial salva. A conta precisa ser validada novamente antes de ser ativada.',
    validated: 'Conexão validada.',
    activated: 'Conta ativada.',
    deactivated: 'Conta desativada.',
    operationFailed: 'Não foi possível concluir a operação.',
  },
  errors: {
    CHANNEL_ACCOUNTS_AUTH_REQUIRED: 'Sua sessão não está autenticada.',
    CHANNEL_ACCOUNTS_TENANT_REQUIRED: 'Não foi possível identificar o tenant.',
    CHANNEL_ACCOUNTS_FORBIDDEN: 'Você não possui acesso a esta tela.',
    CHANNEL_ACCOUNTS_ID_REQUIRED: 'Não foi possível identificar a conta.',
    CHANNEL_ACCOUNTS_CHANNEL_UNSUPPORTED: 'Este canal ainda não possui configuração visual disponível.',
    CHANNEL_ACCOUNTS_CREDENTIAL_INVALID: 'Informe a credencial da conta.',
    CHANNEL_ACCOUNTS_ACTIVATION_INVALID: 'A solicitação de ativação é inválida.',
    CHANNEL_ACCOUNTS_SERVICE_IDENTITY_REQUIRED: 'A identidade interna do AdminDigital para Communication não está configurada.',
    CHANNEL_ACCOUNTS_UPSTREAM_UNAVAILABLE: 'O serviço de comunicação não está disponível.',
    channel_account_request_invalid: 'A configuração da conta é inválida.',
    channel_account_not_found: 'A conta de canal não foi encontrada.',
    channel_account_operation_conflict: 'A conta não pode ser alterada neste estado.',
    channel_account_delete_conflict: 'Desative a conta e conclua entregas pendentes antes de excluí-la.',
    credential_request_invalid: 'A credencial informada é inválida.',
    credential_operation_conflict: 'Já existe uma operação de credencial em andamento ou com conflito.',
    channel_account_validation_invalid: 'Não foi possível validar esta conta.',
    channel_account_not_valid: 'A conta precisa ser validada antes de ser ativada.',
    channel_account_activation_invalid: 'A solicitação de ativação é inválida.',
    provider_registry_unavailable: 'O catálogo de providers está indisponível.',
  },
};
